export enum RoleEnum {
    ADMIN = 'ADMIN',
    VENDOR = 'VENDOR',
  }
       